module.exports = __webpack_public_path__ + "static/media/3.2304969a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/3.jpg
// module id = 595
// module chunks = 0